import React from "react";

const CashWallets = (props) => {
  // const [buttonText, setButtonText] = useState("View My Wallets");

  // // Handle Copy Button Click
  // const handleCopyClick = () => {
  //   const codeText = document.querySelector(".code mark").textContent;
  //   const textarea = document.createElement("textarea");
  //   document.body.appendChild(textarea);
  //   textarea.value = codeText;
  //   textarea.select();

  //   try {
  //     document.execCommand("copy");
  //     setButtonText("Copied!");

  //     // Reset text after 2 seconds
  //     setTimeout(() => {
  //       setButtonText("Copy");
  //     }, 2000);
  //   } catch (err) {
  //     console.error("Copy failed", err);
  //   }

  //   document.body.removeChild(textarea);
  // };

  return (
    <section
      id="id_memecoin_service_section"
      className={`memecoin_service_section bg-white  section_space z-2 pt-0 pb-5 position-relative ${props.tokenClass}`}
    >
      <div class="container">
        <div class="row justify-content-center">
          <div className="col-lg-12">
            <div className="px-4 py-4">
              <div className="mt-4">
                <h1 className="text-theme text-center">
                  TopCoin UK Ltd - Important Tax Information
                </h1>
                <h4 className="text-theme text-center">
                  Applies to Customer Rewards and Reward Payments
                </h4>
                <p className="text-dark text-center opacity-50 mb-0">
                  Effective Date: 6 September 2026
                </p>
                <p className="text-dark text-center opacity-50 mb-0">
                  Company Registration No.: 16483297 | info@topcoinuk.com
                </p>
                <p className="text-dark text-center fw-bold opacity-75 mt-2">
                  TopCoin UK - Transparency | Trust | Loyalty Rewards
                </p>
              </div>
            </div>

            <div className="card shadow-sm border border-opacity-50 bg-white mb-3">
              <div className="card-body">
                <h5 className="text-dark-emphasis py-2">1. Purpose of This Information</h5>
                <p className="text-dark-emphasis mb-2">
                  This document provides general information concerning the possible tax treatment of rewards received through the TopCoin UK and Captain TC loyalty and rewards programmes.
                </p>
                <p className="text-dark-emphasis fw-bold mb-2">
                  It is provided for general information only and does not constitute tax, financial, accounting or legal advice.
                </p>
                <p className="text-dark-emphasis mb-0">
                  Tax treatment can depend on the nature of a reward, how it was earned, the customer's individual circumstances and the tax laws applicable to that customer.
                </p>
              </div>
            </div>

            <div className="card shadow-sm border border-opacity-50 bg-white mb-3">
              <div className="card-body">
                <h5 className="text-dark-emphasis py-2">2. TopCoin UK Loyalty and Rewards</h5>
                <p className="text-dark-emphasis mb-2">
                  TopCoin UK operates an advertising, promotional, customer loyalty and rewards platform.
                </p>
                <p className="text-dark-emphasis mb-2">
                  Customers may receive qualifying TopCoin and other rewards through purchases, transactions, promotions or other qualifying activities specified by TopCoin UK.
                </p>
                <p className="text-dark-emphasis mb-2">
                  TopCoin is a <strong>digital loyalty and reward unit</strong> used within the TopCoin UK platform.
                </p>
                <p className="text-dark-emphasis mb-2">
                  TopCoin itself is not cash and has no standalone monetary or exchange value outside the TopCoin UK rewards system.
                </p>
                <p className="text-dark-emphasis mb-0">
                  TopCoin is not presented by TopCoin UK as interest, a dividend or a promise of investment return.
                </p>
              </div>
            </div>

            <div className="card shadow-sm border border-opacity-50 bg-white mb-3">
              <div className="card-body">
                <h5 className="text-dark-emphasis py-2">3. TopCoin UK Wallets</h5>
                <p className="text-dark-emphasis mb-2">
                  The current TopCoin UK and Captain TC structure may include three separate wallet functions:
                </p>
                <ul className="text-dark-emphasis mb-3">
                  <li><strong>TopCoin Wallet</strong> - records a customer's qualifying original TopCoin.</li>
                  <li><strong>Captain TC Rewards Wallet</strong> - displays the customer's active Captain TC Rewards Card, Captain TC Rewards TopCoin progress and applicable Captain TC rewards earned.</li>
                  <li><strong>Captain TC Gold Wallet</strong> - records qualifying registered Captain TC Gold Cards and applicable Gold Card progress.</li>
                </ul>
                <p className="text-dark-emphasis mb-0">
                  These wallets are programme-recording and display facilities. They should not be understood as conventional bank accounts or payment accounts.
                </p>
              </div>
            </div>

            <div className="card shadow-sm border border-opacity-50 bg-white mb-3">
              <div className="card-body">
                <h5 className="text-dark-emphasis py-2">4. Customer Rewards</h5>
                <p className="text-dark-emphasis mb-2">
                  Depending on the applicable programme and qualifying conditions, customers may become eligible for rewards including cash rewards, gift cards or eGift cards, vouchers, products, promotional benefits or other rewards made available by TopCoin UK.
                </p>
                <p className="text-dark-emphasis mb-0">
                  Captain TC rewards are provided subject to the applicable <strong>Captain TC Rewards Programme Terms &amp; Conditions</strong>.
                </p>
              </div>
            </div>

            <div className="card shadow-sm border border-opacity-50 bg-white mb-3">
              <div className="card-body">
                <h5 className="text-dark-emphasis py-2">5. Tax Treatment of Rewards</h5>
                <p className="text-dark-emphasis mb-2">
                  The tax treatment of loyalty rewards can vary according to the circumstances.
                </p>
                <p className="text-dark-emphasis fw-bold mb-2">
                  TopCoin UK therefore does not state that every reward is automatically taxable or automatically tax-free.
                </p>
                <p className="text-dark-emphasis mb-2">
                  For UK customers, HM Revenue &amp; Customs guidance indicates that the tax treatment of cashback and similar customer rewards depends on the nature and circumstances of the payment. Cashback received by an ordinary customer in connection with purchasing goods or services can be treated differently from payments received in the course of a trade, business or employment.
                </p>
                <p className="text-dark-emphasis mb-0">
                  HMRC also recognises loyalty schemes as marketing arrangements in which customers can accumulate points on qualifying purchases and subsequently redeem those points for rewards.
                </p>
              </div>
            </div>

            <div className="card shadow-sm border border-opacity-50 bg-white mb-3">
              <div className="card-body">
                <h5 className="text-dark-emphasis py-2">6. Receiving or Redeeming a Reward</h5>
                <p className="text-dark-emphasis mb-2">
                  A customer's tax position should not be determined solely by whether a reward is displayed within the TopCoin UK platform, redeemed, paid as cash or transferred to the customer.
                </p>
                <p className="text-dark-emphasis mb-2">
                  The relevant tax treatment may depend on factors including why the reward was received; the customer's relationship with the transaction; whether the customer is acting privately or through a business; whether the reward is connected with employment or trading activity; the form and terms of the reward; and the tax laws applicable to the customer.
                </p>
                <p className="text-dark-emphasis mb-0">
                  Accordingly, TopCoin UK does not guarantee any particular tax treatment.
                </p>
              </div>
            </div>

            <div className="card shadow-sm border border-opacity-50 bg-white mb-3">
              <div className="card-body">
                <h5 className="text-dark-emphasis py-2">7. Customers Using TopCoin UK Privately</h5>
                <p className="text-dark-emphasis mb-2">
                  Customers using TopCoin UK as ordinary consumers to make personal retail purchases may have a different tax position from customers using rewards in connection with a business, trade, profession or employment.
                </p>
                <p className="text-dark-emphasis mb-2">
                  HMRC guidance indicates that cashback received by a person who is not carrying on a trade or property business for choosing one supplier rather than another generally does not fall within the miscellaneous-income rules merely because the customer receives cashback connected with the purchase.
                </p>
                <p className="text-dark-emphasis mb-0">
                  However, individual circumstances can differ.
                </p>
              </div>
            </div>

            <div className="card shadow-sm border border-opacity-50 bg-white mb-3">
              <div className="card-body">
                <h5 className="text-dark-emphasis py-2">8. Business, Employment and Other Circumstances</h5>
                <p className="text-dark-emphasis mb-2">
                  Different tax consequences may arise where rewards are received in the course of a trade or business; in connection with employment; for introducing or referring other customers; as part of commercial activity; or under circumstances materially different from ordinary personal retail participation.
                </p>
                <p className="text-dark-emphasis mb-2">
                  HMRC guidance indicates that cashback received in the course of trading is generally included in taxable trade profits.
                </p>
                <p className="text-dark-emphasis mb-0">
                  Customers receiving rewards in these circumstances should obtain appropriate professional advice.
                </p>
              </div>
            </div>

            <div className="card shadow-sm border border-opacity-50 bg-white mb-3">
              <div className="card-body">
                <h5 className="text-dark-emphasis py-2">9. International Customers</h5>
                <p className="text-dark-emphasis mb-2">
                  Where TopCoin UK or Captain TC Rewards becomes available outside the United Kingdom, customers may be subject to the tax laws of their own country or territory.
                </p>
                <p className="text-dark-emphasis mb-2">
                  Tax rules vary internationally.
                </p>
                <p className="text-dark-emphasis mb-2">
                  TopCoin UK does not guarantee that UK tax treatment will apply to customers resident or taxable outside the United Kingdom.
                </p>
                <p className="text-dark-emphasis mb-0">
                  International customers are responsible for determining whether they have reporting, payment or other tax obligations in their applicable jurisdiction.
                </p>
              </div>
            </div>

            <div className="card shadow-sm border border-opacity-50 bg-white mb-3">
              <div className="card-body">
                <h5 className="text-dark-emphasis py-2">10. Customer Responsibility</h5>
                <p className="text-dark-emphasis mb-2">
                  Customers are responsible for understanding and complying with any tax obligations that apply to them.
                </p>
                <p className="text-dark-emphasis mb-2">
                  Where appropriate, customers should retain relevant records of rewards received through TopCoin UK.
                </p>
                <p className="text-dark-emphasis mb-0">
                  Customers who are uncertain about their tax position should consult <strong>HM Revenue &amp; Customs (HMRC)</strong>, the relevant tax authority in their country, or a suitably qualified tax adviser or accountant.
                </p>
              </div>
            </div>

            <div className="card shadow-sm border border-opacity-50 bg-white mb-3">
              <div className="card-body">
                <h5 className="text-dark-emphasis py-2">11. No Tax or Financial Advice</h5>
                <p className="text-dark-emphasis mb-2">
                  TopCoin UK Ltd does not provide individual tax, accounting, investment or financial advice.
                </p>
                <p className="text-dark-emphasis mb-2">
                  Information provided on the TopCoin UK platform concerning rewards or taxation is general information only.
                </p>
                <p className="text-dark-emphasis mb-0">
                  Customers should not rely upon TopCoin UK to determine their personal tax liability.
                </p>
              </div>
            </div>

            <div className="card shadow-sm border border-opacity-50 bg-white mb-3">
              <div className="card-body">
                <h5 className="text-dark-emphasis py-2">12. Important Legal Information</h5>
                <p className="text-dark-emphasis mb-2">
                  Participation in the TopCoin UK or Captain TC Rewards Programme does not by itself create an employment relationship between the customer and TopCoin UK.
                </p>
                <p className="text-dark-emphasis mb-2">
                  TopCoin UK rewards are provided as part of loyalty, advertising, promotional and customer-reward activities and are subject to the applicable programme terms.
                </p>
                <p className="text-dark-emphasis mb-0">
                  Nothing in this document should be interpreted as a guarantee that a particular reward will be tax-free or taxable.
                </p>
              </div>
            </div>

            <div className="card shadow-sm border border-opacity-50 bg-white mb-3">
              <div className="card-body">
                <h5 className="text-dark-emphasis py-2">13. Changes to This Information</h5>
                <p className="text-dark-emphasis mb-2">
                  Tax legislation and HMRC guidance may change.
                </p>
                <p className="text-dark-emphasis mb-2">
                  TopCoin UK may update this document where appropriate to reflect changes to the programme, applicable law or relevant tax guidance.
                </p>
                <p className="text-dark-emphasis mb-0">
                  Customers remain responsible for obtaining current advice appropriate to their individual circumstances.
                </p>
              </div>
            </div>

            <div className="card shadow-sm border border-opacity-50 bg-white mb-3">
              <div className="card-body">
                <h5 className="text-dark-emphasis py-2">14. Contact</h5>
                <p className="text-dark-emphasis mb-2">
                  For questions about the operation of TopCoin UK rewards, contact:
                </p>
                <p className="text-dark-emphasis mb-3">
                  <strong>TopCoin UK Ltd</strong><br />
                  Company Registration No.: 16483297<br />
                  Email: <strong>info@topcoinuk.com</strong>
                </p>
                <p className="text-dark-emphasis mb-0">
                  For questions about an individual's tax liability, customers should contact the appropriate tax authority or a qualified tax professional.
                </p>
              </div>
            </div>
            <p className="text-black text-center mb-0 fw-bold">
              TopCoin UK - Transparency | Trust | Loyalty Rewards
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CashWallets;
